module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZUlEQVQ4T5WTS4sTURCFv28zQREGZu0fETcKGVxPVKLxhU5gcKOLUf+CIChuXPkGDfiYwe2AiPHvqBsVDHFRUuHe0DZqMg0N1VV9T9U5da40nohYA24D54GDpTQBRsAt9Wvz/4ytiYg4Cbwt32Mg3wCOAt2S76uvmyAzgIjoATvAHnBK/dGarAO8BLLJabU2wog4BHwH3qvr7RFbQG+yAbCqfptRiIjnwEV1TmcBSNIaqecqQCbG6rH/HWxolVR7tWFOkAA31LtLAgyBh0BHnVaAbfXekgBXgMfAAXVSARYK2KCQ2xg0KaRJzu5TxHfqRhUx3ZcOe6WeWbCBR8BmHX/uxIi4DtwHngJb6q/W/nPFD4CrwAX1Ra03rXwJeFYKu8CnEh8B+iUeADeBz+qJP+5CsfRh4E6x7Eo5NC02v6Z+iYgPwPHchDr8p/siIm9jqD/bukTEE+Ay8HEp+/5N2IjIi9f9Daktksc9kNoCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/search.png
// module id = cmkS
// module chunks = 1